import React from "react";
import FaqAccordion from "../components/FaqAccordion";
import BlogSection from "../components/BlogSection";

const Blogs = () => {
  return (
    <div>
      <BlogSection />
      <FaqAccordion />
    </div>
  );
};

export default Blogs;
